import { useAuth0 } from '@auth0/auth0-react';
import { Navigate } from 'react-router-dom';
import { RoutesTypes } from '../router/routerTypes';
import { Spin } from 'antd';

const AuthProtectedPage = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated, isLoading } = useAuth0();

  if (isLoading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '48px' }}>
        <Spin />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={`/${RoutesTypes.Auth}`} />;
  }

  return <>{children}</>;
};

export default AuthProtectedPage;
